import { c as _c } from "react/compiler-runtime";
import { useRequestError } from '@onefootprint/fetch-hosted/src/use-request-error';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoCheckCircle40 } from '@onefootprint/icons';
import { HeaderTitle } from '@onefootprint/idv';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHostedMachine } from 'src/components/hosted-machine-provider';
const ErrorPage = () => {
  const $ = _c(5);
  const {
    getErrorCode
  } = useRequestError();
  const [state] = useHostedMachine();
  const {
    error
  } = state.context;
  const errorCode = getErrorCode(error);
  const isLinkAlreadyUsedError = errorCode === "E125";
  if (isLinkAlreadyUsedError) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LinkAlreadyUsedError />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const isExpiredError = errorCode === "E118";
  if (isExpiredError) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <LinkExpiredError />;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  const isCancelledError = errorCode === "E138";
  if (isCancelledError) {
    let t0;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <RequestCancelledError />;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== error) {
    t0 = <GenericError error={error} />;
    $[3] = error;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
const LinkAlreadyUsedError = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.errorPage"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoCheckCircle40 color="success" />;
    t2 = <div className="mb-3" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-col items-center justify-center pt-7">{t1}{t2}<HeaderTitle title={t3} subtitle={t4} /></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const LinkExpiredError = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.errorPage"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp3);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp4);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="flex flex-col justify-center items-center gap-6 pt-7"><HeaderTitle title={t1} subtitle={t2} /></div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const RequestCancelledError = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.errorPage"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoCheckCircle40 color="success" />;
    t2 = <div className="mb-3" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp5);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp6);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex flex-col items-center justify-center pt-7">{t1}{t2}<HeaderTitle title={t3} subtitle={t4} /></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
const GenericError = t0 => {
  const $ = _c(12);
  const {
    error
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.errorPage"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  const showRequestError = useRequestErrorToast();
  let t2;
  if ($[1] !== error || $[2] !== showRequestError) {
    t2 = () => {
      showRequestError(error);
    };
    $[1] = error;
    $[2] = showRequestError;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp7);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp8);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="pt-8"><HeaderTitle title={t4} subtitle={t5} /></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ErrorPage;
function _temp($) {
  return $.linkUsed.title;
}
function _temp2($_0) {
  return $_0.linkUsed.subtitle;
}
function _temp3($) {
  return $.expired.title;
}
function _temp4($_0) {
  return $_0.expired.subtitle;
}
function _temp5($) {
  return $.cancelledRequest.title;
}
function _temp6($_0) {
  return $_0.cancelledRequest.subtitle;
}
function _temp7($) {
  return $.generic.title;
}
function _temp8($_0) {
  return $_0.generic.subtitle;
}